import { observer } from 'mobx-react-lite';
import ProductMenuItem from '@features/navigation/components/ProductMenuItem/ProductMenuItem';
import styles from '@features/navigation/components/Navigation/Navigation.styles';
import { ICategory } from '@features/categories';

type PropsType = {
  products: ICategory[];
  color: string;
  onClick: (product: ICategory) => void;
  selectedGroup: ICategory | null;
};

const ProductMenuDesktop = ({ products, color, onClick, selectedGroup }: PropsType) => (
  <ul sx={styles.productMenuContainer}>
    {products.map((product) => {
      const isActive = selectedGroup?.id === product.id;
      return (
        <ProductMenuItem
          key={product.id}
          product={product}
          color={color}
          isMobile={false}
          onClick={onClick}
          isActive={isActive}
          cy={`Desktop-MenuItem-${product.slug}`}
        />
      );
    })}
  </ul>
);

export default observer(ProductMenuDesktop);
